import { hotPosts } from "@/mocks/homeData";

export default function TrendingRanking() {
  return (
    <section id="ranking" className="bg-background-100 py-14 md:py-24">
      <div className="px-4 md:px-10 max-w-5xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 pb-8 md:pb-10 border-b border-background-300">
          <div>
            <span className="text-primary-600 text-xs md:text-sm tracking-[0.2em] uppercase">
              HOT RANKING
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              吃瓜热帖排行
            </h2>
          </div>
          <span className="inline-flex items-center gap-2 self-start sm:self-auto text-xs md:text-sm text-foreground-600">
            <span className="relative w-2 h-2 flex items-center justify-center">
              <span className="absolute w-2 h-2 rounded-full bg-primary-500/40 animate-ping"></span>
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            </span>
            实时更新中 · 每分钟刷新
          </span>
        </div>

        <ol className="mt-2">
          {hotPosts.map((post) => (
            <li
              key={post.rank}
              className="flex gap-4 md:gap-7 py-6 md:py-7 border-b border-background-300 last:border-0"
            >
              <span
                className={`font-heading text-3xl md:text-5xl font-bold leading-none w-9 md:w-16 shrink-0 pt-1 ${
                  post.rank <= 3 ? "text-primary-600" : "text-foreground-300"
                }`}
              >
                {String(post.rank).padStart(2, "0")}
              </span>

              <div className="flex-1 min-w-0">
                <h4 className="flex items-start flex-wrap gap-x-2 gap-y-1">
                  <a
                    href="#ranking"
                    className="font-heading text-base md:text-xl font-semibold text-foreground-950 hover:text-primary-600 cursor-pointer transition-colors"
                  >
                    {post.title}
                  </a>
                  {post.fresh && (
                    <span className="mt-0.5 px-1.5 py-0.5 rounded bg-primary-500 text-background-50 text-[10px] font-medium tracking-wide">
                      NEW
                    </span>
                  )}
                </h4>

                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                  {post.summary}
                </p>

                <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">
                    {post.tag}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-fire-line text-primary-500"></i>
                    </span>
                    热度 {post.heat}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-chat-3-line"></i>
                    </span>
                    {post.comments} 条热评
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-8 flex justify-center">
          <a
            href="#ranking"
            className="inline-flex items-center gap-2 whitespace-nowrap border border-foreground-300 hover:border-primary-500 hover:text-primary-600 text-foreground-800 text-sm px-6 py-2.5 rounded-md cursor-pointer transition-colors"
          >
            查看更多火爆帖
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}